import { createMuiTheme } from "@material-ui/core/styles";

export const ValmetGrey0 = "#1d1d1d";
export const ValmetGrey1 = "#2d2d2d";
export const ValmetGrey2 = "#333333";
export const ValmetGrey3 = "#4c4d4f";
export const ValmetGrey4 = "#666666";
export const ValmetGrey6 = "#8b8d8e";
export const ValmetGrey9 = "#bdbdbd";
export const ValmetGrey10 = "#c1c2c5";
export const ValmetGrey12 = "#e0e1dd";
export const ValmetGrey13 = "#e5e5e5";
export const ValmetGrey14 = "#ececec";
export const ValmetGrey15 = "#f6f7f8";
export const ValmetGrey16 = "#fdfdfd";

export const ValmetRed6 = "#ff0043";

export const ValmetYellow1 = "#f4aa00";

export const ValmetGreen1 = "#50b948";

export const ValmetWhite = "#ffffff";

export const ValmetCommonHighlight = "#00b4e4";
export const ValmetMenuHeaderBg = "#414142";
export const ValmetCommonBackground = "#dddddd";
export const ValmetDefaultText = "#222326";
export const ValmetAlarm = "#c41230";
export const ValmetWarning = "#f89a41";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: ValmetGreen1,
    },
    secondary: {
      main: ValmetGrey16,
    },
  },

  props: {
    MuiAppBar: {
      elevation: 0,
    },
    MuiTab: {
      disableTouchRipple: true,
    },
    MuiIconButton: {
      disableTouchRipple: true,
    },
    MuiPopover: {
      elevation: 1,
    },
    MuiPaper: {
      square: true,
    },
    MuiTableRow: {
      hover: true,
    },
    MuiList: {
      disablePadding: true,
    },
    MuiMenu: {
      marginThreshold: 8,
    },
  },

  overrides: {
    MuiFormControlLabel: {
      label: {
        fontSize: "13px",
      },
    },

    MuiAppBar: {
      colorPrimary: {
        backgroundColor: ValmetGrey4,
      },
    },

    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
        backgroundColor: ValmetCommonBackground,
      },
      inputMarginDense: {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },

    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: ValmetCommonBackground,
        },
      },
    },

    MuiList: {
      root: {
        // Disable just in case
        outline: 0,
      },
    },

    MuiListItem: {
      button: {
        "&:hover": {
          backgroundColor: ValmetGrey1,
        },
        height: 48,
        "&$selected": {
          color: ValmetCommonHighlight,
          backgroundColor: "inherit",
          // Hover when selected
          "&:hover": {
            backgroundColor: ValmetGrey1,
          },
        },
        // Focus
        "&$focusVisible": {
          backgroundColor: ValmetGrey1,
        },
      },
    },

    MuiListItemText: {
      root: {
        marginLeft: 11,
      },
      primary: {
        fontSize: 14,
      },
    },

    MuiMenuItem: {
      root: {
        height: "inherit",
        "&:hover": {
          backgroundColor: ValmetCommonBackground,
        },
        "&$selected": {
          "&:hover": {
            backgroundColor: ValmetCommonBackground,
          },
          "&:focus": {
            backgroundColor: ValmetCommonBackground,
          },
        },
        "&:focus": {
          backgroundColor: ValmetCommonBackground,
        },
      },
    },

    MuiTypography: {
      h1: {
        fontSize: "1.3rem",
        fontWeight: "bold",
      },
      h2: {
        fontSize: "1.1rem",
        fontWeight: "bold",
      },
      h3: {
        fontSize: "1rem",
        fontWeight: "bold",
      },
      subtitle1: {
        fontSize: 24,
      },
      subtitle2: {
        fontSize: "0.7rem",
      },
    },

    MuiTooltip: {
      tooltip: {
        backgroundColor: ValmetWhite,
        color: ValmetDefaultText,
        maxWidth: 220,
        fontSize: 13,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: ValmetGrey12,
        borderRadius: 1,
        boxShadow: "0px 0px 1px 0px rgba(0, 0, 0, 0.33)",
      },
    },

    MuiIconButton: {
      colorSecondary: {
        "&$disabled": {
          color: ValmetGrey6,
        },
      },
    },

    MuiTabs: {
      indicator: {
        display: "none",
      },
    },

    MuiTab: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
        "&$selected": {
          color: ValmetCommonHighlight,
        },
        "&:not(:first-of-type)": {
          "&:before": {
            content: '" "',
            position: "absolute",
            left: 0,
            bottom: 10, // Manual fix for IE11
            display: "block",
            height: 28,
            width: 1,
            zIndex: 1,
            backgroundColor: ValmetGrey16,
          },
        },
      },

      textColorInherit: {
        minWidth: 48,
      },
    },

    MuiTableCell: {
      stickyHeader: {
        backgroundColor: ValmetGrey9,
        color: ValmetGrey3,
        fontWeight: "bold",
      },

      sizeSmall: {
        color: ValmetGrey3,
      },
    },

    MuiTableRow: {
      root: {
        "&$hover:hover": {
          color: "inherit",
          backgroundColor: `${ValmetCommonHighlight}26`,
        },
      },

      footer: {
        backgroundColor: ValmetGrey14,
      },
    },

    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: ValmetWhite,
      },
    },

    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: ValmetWhite,
      },
    },

    MuiPickersDay: {
      daySelected: {
        color: ValmetWhite,
        backgroundColor: ValmetCommonHighlight,
      },
    },

    MuiPickersClockNumber: {
      clockNumberSelected: {
        color: ValmetWhite,
        backgroundColor: ValmetCommonHighlight,
      },
    },
  },
});

export default theme;
